<div class="ec-status-card">

  <!-- ── LOADING ────────────────────────────────────── -->
  <div *ngIf="isLoading" class="ec-loading">
    <span class="ec-spinner"></span>
    <span class="ec-loading-text">Loading...</span>
  </div>

  <!-- ── ERROR ──────────────────────────────────────── -->
  <div *ngIf="hasError && !isLoading" class="ec-error">
    Failed to load execution data.
    <button class="ec-retry-btn" (click)="fetchData()">Retry</button>
  </div>

  <!-- ── CONTENT ────────────────────────────────────── -->
  <ng-container *ngIf="!isLoading && !hasError && data">

    <!-- ── HEADER ─────────────────────────────────────── -->
    <div class="ec-header">
      <div class="ec-header-left">
        <span class="ec-name">{{ data.name }}</span>

        <span *ngIf="data.release" class="ec-release-badge">
            {{ data.release?.name }}
        </span>
      </div>

      <div class="ec-header-right">
        <span class="ec-test-count">
          <!-- test-case icon -->
            <img src="assets/images/virtusa-icons/document-icon.svg" alt="add" />
          <span>{{ data.totalCount ?? 0 }} Test Case(s)</span>
        </span>

        <app-status-badge [status]="data.status" [size]="'medium'"></app-status-badge>
      </div>
    </div>

    <!-- ── GREEN PROGRESS BAR ─────────────────────────── -->
    <div class="ec-progress-bar"></div>

    <!-- ── BODY ──────────────────────────────────────── -->
    <div class="ec-body">
      <h4 class="ec-section-title">Execution Timeline</h4>

      <div class="ec-timeline-card">
        <div class="ec-timeline-row">
          <span class="ec-tl-label">Start Time</span>
          <span class="ec-tl-value">{{ formatDate(data.startTime) }}</span>
        </div>

        <div class="ec-timeline-row">
          <span class="ec-tl-label">End Time</span>
          <span class="ec-tl-value">{{ formatDate(data.endTime) }}</span>
        </div>

        <div class="ec-timeline-row">
          <span class="ec-tl-label">Duration</span>
          <span class="ec-tl-value ec-tl-duration">{{ calculateDuration() }}</span>
        </div>
      </div>
    </div>

    <!-- ── FOOTER ─────────────────────────────────────── -->
    <div class="ec-footer">
      <button class="btn-accello-primary" (click)="onViewResults()">
        Test Execution Results
      </button>
    </div>

  </ng-container>

</div>
